import React from 'react';
import { motion } from 'framer-motion';
import { FileSpreadsheet, FileX2, Scale } from 'lucide-react';

const BENEFITS = [
    {
        title: 'Zero papel',
        description: 'A folha física sai da rotina. Sem impressão, carimbo ou redigitação: o DP reduz o custo de papel e o tempo gasto para recolher cartões de ponto.',
        icon: FileX2,
    },
    {
        title: 'Acesso do contador',
        description: 'A contabilidade entra em um painel simples e exporta relatórios e folhas mensais auditáveis com 1 clique, no ritmo do fechamento.',
        icon: FileSpreadsheet,
    },
    {
        title: 'Segurança jurídica',
        description: 'Marcações com geolocalização, assinatura digital e trilha imutável dão conformidade e reduzem passivos trabalhistas.',
        icon: Scale,
    },
];

const BeneficiosPontoSection = () => (
    <section id="beneficios" className="scroll-mt-20 border-t border-slate-200/80 bg-white py-16 dark:border-slate-800 dark:bg-slate-950 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.45 }}
                className="mx-auto max-w-2xl text-center"
            >
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-emerald-600">
                    DP e contabilidade
                </p>
                <h2 className="mt-3 text-3xl font-black tracking-tight text-slate-900 dark:text-white sm:text-4xl">
                    O ponto que fecha o mês sem retrabalho
                </h2>
                <p className="mt-4 text-base leading-relaxed text-slate-600 dark:text-slate-300 sm:text-lg">
                    O módulo entrega a jornada pronta para o departamento pessoal e para o escritório contábil.
                </p>
            </motion.div>

            <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
                {BENEFITS.map((benefit, index) => {
                    const Icon = benefit.icon;
                    return (
                        <motion.article
                            key={benefit.title}
                            initial={{ opacity: 0, y: 18 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-60px' }}
                            transition={{ duration: 0.4, delay: index * 0.08 }}
                            className="rounded-3xl border border-slate-200 bg-slate-50 p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-emerald-200 hover:shadow-lg dark:border-slate-800 dark:bg-slate-900 dark:hover:border-emerald-500/40"
                        >
                            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-600 dark:text-emerald-300">
                                <Icon className="h-6 w-6" />
                            </div>
                            <h3 className="mt-5 text-xl font-bold text-slate-900 dark:text-white">
                                {benefit.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300 sm:text-base">
                                {benefit.description}
                            </p>
                        </motion.article>
                    );
                })}
            </div>
        </div>
    </section>
);

export default BeneficiosPontoSection;
